import React, { useState } from 'react';

export default function SignatureCell({ value }) {
  const [showPreview, setShowPreview] = useState(false);
  const [signatureData, setSignatureData] = useState(null);
  const [loadingSignature, setLoadingSignature] = useState(false);

  if (!value) return <span />;

  // Full base64 image (per_page <= 30)
  if (!value.startsWith('signed:')) {
    return (
      <img src={value} alt="Firma" className="cm-cell-signature" loading="lazy" />
    );
  }

  // Compact mode: "signed:surveyId:questionId"
  const parts = value.split(':');
  const surveyId = parts[1];
  const questionId = parts[2];

  const handleOpen = async (e) => {
    e.stopPropagation();
    setShowPreview(true);
    if (!signatureData) {
      setLoadingSignature(true);
      try {
        const res = await fetch(`/formatos/records/signature/${surveyId}/${questionId}`);
        const json = await res.json();
        setSignatureData(json.signature);
      } catch (err) {
        console.error('Error loading signature:', err);
      } finally {
        setLoadingSignature(false);
      }
    }
  };

  return (
    <>
      <span className="cm-cell-signed" onClick={handleOpen}>
        <i className="fas fa-signature" /> Firmado
      </span>
      {showPreview && (
        <div className="cm-modal-overlay" onClick={() => setShowPreview(false)}>
          <div className="cm-modal-richtext cm-modal-richtext--preview" onClick={e => e.stopPropagation()}>
            <div className="cm-modal-richtext__header">
              <span className="cm-modal-richtext__title">Firma</span>
              <button className="cm-modal-richtext__close" onClick={() => setShowPreview(false)}>
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="cm-modal-richtext__body cm-modal-richtext__body--preview" style={{ padding: 20, textAlign: 'center' }}>
              {loadingSignature ? (
                <i className="fas fa-spinner fa-spin" style={{ fontSize: 24, color: '#aaa' }} />
              ) : signatureData ? (
                <img src={signatureData} alt="Firma" style={{ maxWidth: '100%', maxHeight: 300 }} />
              ) : (
                <p style={{ color: '#888' }}>No se pudo cargar la firma</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
